import React from 'react';
import './MaterialCard.css';
import starIcon from '../assets/icons/star.svg';
import starFillIcon from '../assets/icons/star-fill.svg';
import blockIcon from '../assets/icons/block.svg';

const MaterialCard = ({ 
  material, 
  onToggleFavorite,
  appData
}) => {
  const handleCardClick = () => {
    if (material.external_link) {
      window.open(material.external_link, '_blank', 'noopener,noreferrer');
    }
  };

  const handleFavoriteClick = (e) => {
    e.stopPropagation(); // Предотвращаем всплытие события
    onToggleFavorite(material.id);
  };

  const textColor = material.text_color || 'var(--color-white)';
  const buttonColor = material.button_color || 'var(--color-secondary)';
  const buttonTextColor = material.button_text_color || 'var(--color-white)';

  return (
    <div className="material-card" onClick={handleCardClick}>
      {/* Верхняя часть с изображением */}
      <div className="material-image">
        {material.image ? (
          <img 
            src={material.image} 
            alt={material.title}
            loading="lazy"
            decoding="async"
            onError={(e) => {
              console.warn('Failed to load material image:', material.image);
              if (e.target) {
                e.target.style.display = 'none';
                const placeholder = e.target.parentNode?.querySelector('.material-image-placeholder');
                if (placeholder) {
                  placeholder.style.display = 'flex';
                }
              }
            }}
            onLoad={(e) => {
              // Плавно показываем изображение после загрузки
              if (e.target) {
                requestAnimationFrame(() => {
                  e.target.style.opacity = '1';
                });
              }
            }}
            className="material-image-loaded high-quality-image"
          />
        ) : null}
        {!material.image && (
          <div className="material-image-placeholder placeholder-image">
            <img 
              src="/assets/images/material.png" 
              alt={material.title} 
              className="placeholder-material"
              loading="lazy"
              decoding="async"
            />
          </div>
        )}
        
        {/* Иконка избранного */}
        {appData?.configs?.fav_on === "true" && (
          <div className="favorite-btn-container">
            <button 
              className={`favorite-btn ${material.is_favorite ? 'active' : ''}`}
              onClick={handleFavoriteClick}
              title={material.is_favorite ? 'Удалить из избранного' : 'Добавить в избранное'}
              aria-label={material.is_favorite ? 'Удалить из избранного' : 'Добавить в избранное'}
            >
              <img 
                src={material.is_favorite ? starFillIcon : starIcon} 
                alt={material.is_favorite ? 'Удалить из избранного' : 'Добавить в избранное'}
                className="favorite-icon"
                loading="lazy"
                decoding="async"
              />
            </button>
          </div>
        )}

        {/* Черный слой и иконка замка для материалов без ссылок */}
        {!material.external_link && (
          <>
            <div className="material-overlay"></div>
            <div className="lock-icon-container">
              <img 
                src={blockIcon} 
                alt="Заблокировано" 
                className="lock-icon"
                loading="lazy"
                decoding="async"
              />
            </div>
          </>
        )}
      </div>

      {/* Нижняя часть с контентом */}
      <div className="material-content">
        {/* Заголовок */}
        <h3 
          className="material-title"
          style={{ color: textColor }}
        >
          {material.title}
        </h3>
        
        {/* Кнопка открытия */}
        {material.external_link && (
          <button 
            className="open-btn"
            style={{ backgroundColor: buttonColor, color: buttonTextColor }}
          >
            Открыть
          </button>
        )}
      </div>
    </div>
  );
};

export default MaterialCard; 